<template>
    <div>
        <v-card-text v-if="isLoading && !items.length" class="text-center">
            <v-progress-circular indeterminate />
        </v-card-text>

        <v-list v-else>
            <div v-for="(fb, idx) in items" :key="`fb-${fb.id}`">
                <v-list-item @click="$emit('select', fb)">
                    <v-list-item-icon>
                        <v-icon size="18" :color="getStatusColor(status)">
                            {{ icons.mdiCircle }}
                        </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title class="text-body-2">
                            <v-chip v-if="fb.internal_title" small color="primary" text-color="white" class="mb-1">
                                {{ fb.internal_title }}
                            </v-chip>
                            <div>
                                {{ fb.preview }}
                            </div>
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-caption">
                            <i>{{ getDateTime(fb.insert_date) }}</i>
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action v-if="fb.internal_title || fb.category" class="d-flex flex-column align-end">

                        <v-chip v-if="fb.category" small>{{ fb.category }}</v-chip>
                    </v-list-item-action>
                </v-list-item>

                <v-divider v-if="idx < items.length - 1"></v-divider>
            </div>

            <v-list-item v-if="!items.length">
                <v-list-item-content>
                    <v-alert dense text type="info">{{ emptyText }}</v-alert>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mdiCircle } from "@mdi/js";
import { getDateTime } from "@/@core/utils/datetime_helpers";

export default {
    name: "FeedbackDashboardList",
    props: {
        items: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
        status: {
            type: Number,
            required: true,
        },
        emptyText: {
            type: String,
            required: true,
        },
    },
    setup() {
        const getStatusColor = (status) => {
            switch (status) {
                case 1:
                    return "error";
                case 2:
                    return "warning";
                case 3:
                    return "success";
                default:
                    return "error";
            }
        };

        return {
            getDateTime,
            getStatusColor,
            icons: {
                mdiCircle,
            },
        };
    },
};
</script>

<style scoped></style>
